import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { blogData } from "../Data/blogs";
import { Helmet } from "react-helmet";
import { websiteTitle, websiteURL } from "../helper/constants";
import NavbarBlogs from "../components/NavbarBlogs";
import Footer from "../components/Footer";

export default function BlogDetails() {
  useEffect(() => {
    // Scroll to top when the page is rendered
    window.scrollTo(0, 0);
  }, []);

  const { slug } = useParams();
  const blog = blogData.find((b) => b.slug === slug);

  if (!blog) {
    return <h1 className="text-center text-2xl">Blog Not Found</h1>;
  }

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: blog.title,
    description: blog.desc,
    image: blog.image,
    author: {
      "@type": "Person",
      name: blog.author,
    },
    datePublished: blog.date,
    url: `${websiteURL}/blogs/${slug}`,
  };

  return (
    <>
      <NavbarBlogs blogs />
      <div className="container mx-auto py-36 px-4">
        <Helmet>
          <title>{blog.title} - {websiteTitle}</title>
          <meta name="description" content={blog.desc} />
          <meta property="og:title" content={blog.title} />
          <meta property="og:description" content={blog.desc} />
          <meta property="og:image" content={blog.image} />
          <script type="application/ld+json">
            {JSON.stringify(structuredData)}
          </script>
        </Helmet>

        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">{blog.title}</h1>
        <p className="text-sm text-gray-500 mt-1">
          By {blog.author} on {blog.date}
        </p>

        <img
          src={blog.image}
          alt={blog.title}
          className="w-full h-96 object-cover mt-6 rounded-lg"
        />

        <p className="text-lg text-gray-700 dark:text-gray-300 mt-8">{blog.desc}</p>

        {/* Dynamic Blog Content Sections */}
        {blog.content && blog.content.map((section, index) => (
          <div key={index} className="mt-10">
            <h2 className="text-2xl font-semibold text-gray-800 dark:text-white mb-4">
              {section.heading}
            </h2>
            {section.paragraphs.map((para, idx) => (
              <p
                key={idx}
                className="text-base text-gray-700 dark:text-gray-300 mb-4 leading-relaxed"
              >
                {para}
              </p>
            ))}

            {/* Check and render list if available */}
            {section.list && section.list.length > 0 && (
              <ul
                style={{ listStyleType: "disc", paddingLeft: "1.5rem", margin: 0 }}
                className="text-gray-700 dark:text-gray-300 mb-4 space-y-2 list-disc"
              >
                {section.list.map((item, listIdx) => (
                  <li
                    key={listIdx}
                    style={{ marginLeft: "0.5rem" }}
                  // className="pl-1" // Optional: small left pad for text if needed
                  >
                    {item}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
      <Footer />
    </>
  );
}
